const NO_DATA_MESSAGE = "Sorry, we couldn't find any repairs with those details.";

export { NO_DATA_MESSAGE };
